import React, { useMemo, useState } from "react";
import { message } from "antd";
import Tabs from "../../Components/Tabs";
import Card from "../../Components/Card";
import DropdownManager from "../../Components/admin/masterdata/DropdownManager";
import OptionsManager from "../../Components/admin/masterdata/OptionsManager";

const MasterData = () => {
  const [activeTab, setActiveTab] = useState("fields");
  const [messageApi, contextHolder] = message.useMessage();

  const tabs = useMemo(
    () => [
      { id: "fields", label: "Dropdown Fields" },
      { id: "options", label: "Dropdown Options" },
    ],
    []
  );

  return (
    <div className="w-full space-y-4">
      {contextHolder}
      <Card
        header={
          <div className="flex flex-col gap-1">
            <div className="text-base font-semibold text-slate-900">Master Data</div>
            <div className="text-xs font-normal text-slate-500">
              Manage dropdown fields and options.
            </div>
          </div>
        }
      >
        <div className="space-y-4">
          <Tabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />

          {activeTab === "fields" ? <DropdownManager toast={messageApi} /> : null}
          {activeTab === "options" ? <OptionsManager toast={messageApi} /> : null}
        </div>
      </Card>
    </div>
  );
};

export default MasterData;

